// Lightweight helpers to mutate <head> tags for per-route SEO in a React SPA.
// Googlebot's 2nd-pass (JS render) picks up these updates for indexing.
// These helpers are intentionally idempotent — safe to call on every route change.

export const upsertMetaByName = (name, content) => {
  if (typeof document === 'undefined') return;
  let tag = document.head.querySelector(`meta[name="${name}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute('name', name);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', content);
};

export const upsertMetaByProperty = (prop, content) => {
  if (typeof document === 'undefined') return;
  let tag = document.head.querySelector(`meta[property="${prop}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute('property', prop);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', content);
};

export const upsertCanonical = (href) => {
  if (typeof document === 'undefined') return;
  let tag = document.head.querySelector('link[rel="canonical"]');
  if (!tag) {
    tag = document.createElement('link');
    tag.setAttribute('rel', 'canonical');
    document.head.appendChild(tag);
  }
  tag.setAttribute('href', href);
};

export const upsertJsonLd = (id, data) => {
  if (typeof document === 'undefined') return;
  let tag = document.head.querySelector(`script[data-seo-id="${id}"]`);
  if (!tag) {
    tag = document.createElement('script');
    tag.setAttribute('type', 'application/ld+json');
    tag.setAttribute('data-seo-id', id);
    document.head.appendChild(tag);
  }
  tag.textContent = JSON.stringify(data);
};

// Remove a JSON-LD block by id — used when a component unmounts so schemas
// from one page don't leak into another.
export const removeJsonLd = (id) => {
  if (typeof document === 'undefined') return;
  const tag = document.head.querySelector(`script[data-seo-id="${id}"]`);
  if (tag) tag.remove();
};

// Strip HTML tags and collapse whitespace — useful to generate a plain-text
// description from rich-text blog content.
export const stripHtml = (html = '', maxLength = 160) => {
  if (!html) return '';
  const text = html
    .replace(/<style[\s\S]*?<\/style>/gi, '')
    .replace(/<script[\s\S]*?<\/script>/gi, '')
    .replace(/<[^>]+>/g, ' ')
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/\s+/g, ' ')
    .trim();
  if (text.length <= maxLength) return text;
  return text.slice(0, maxLength - 1).trimEnd() + '…';
};
